<template lang="pug">
    include ../../media/pug/mixins
    +b.SIDEBAR-TAB.orders-list(
        name="orders-list"
    )
        template(v-slot:header="")
            +e.H2.title.title._size_md._theme_secondary.orders-list__title {{ $t('ORDERS') }}
            +e.navigation.orders-list__navigation(v-if="!(isMobile && getOrderId !== null)")
                +e.tab(
                    v-bind:class="{'orders-list__tab_active': currentTab === 'current'}"
                    v-on:click="switchTab('current')"
                ) {{ $t('CURRENT') }}
                +e.tab(
                    v-bind:class="archiveTabStyles"
                    v-on:click="switchTab('archive')"
                ) {{ $t('ARCHIVE') }}
            +e.navigation_order(v-else)
                +e.BUTTON.return-btn.btn(
                    v-on:click="$store.commit('SET_CURRENT_ORDER_ID', null)"
                ) {{ $t('BACK') }}
                +e.BUTTON.delete-btn.btn(
                    v-if="currentTab !== 'archive'"
                    v-on:click="deleteOrder(getOrderId)"
                ) {{ $t('DELETE_ORDER') }}
        template(v-slot:container="")
            +e.cards(v-if="!(isMobile && getOrderId !== null)")
                template(v-if="currentTab === 'current'")
                    -// проверка того что мы внутри таба "текущие"
                    template(v-if="currentOrders.length > 0")
                        -// отрисовка текущих заказов
                        order-card(
                            v-for="order in currentOrders"
                            v-bind:key="`order-current-${order.id}`"
                            v-bind:order="order"
                            v-bind:type="'current'"
                            v-on:orderDelete="deleteOrder"
                        )
                    +e.text(v-else-if="!isMobile") {{ $t('YOU_HAVE_NO_ORDERS') }}
                    +e.text(v-else-if="isMobile")
                        | {{ $t('YOU_HAVE_NO_CURRENT_ORDERS_TO_ADD_ORDER_CHECK_IT_OUT_IN') }}
                        +e.SPAN.cart-link.link(
                            v-on:click="$store.commit('SET_CURRENT_SIDEBAR_TAB', 'ShopCart')"
                        ) {{ $t('IN_CART') }}
                    -// отрисовка надписи того что текущих заказов нет
                template(v-else)
                    -// проверка того что мы внутри таба "архив"
                    order-card(
                        v-for="order in archiveOrders"
                        v-bind:key="`order-archive-${order.id}`"
                        v-bind:order="order"
                        v-bind:type="'archive'"
                        v-on:orderDelete="deleteOrder"
                    )
            +e.order-info(v-else)
                -// здесь идет отрисовка выбранного заказа внутрь body сайдбара на мобидке
                cart-item(
                    v-for="item in 3"
                    v-bind:key="item"
                    v-bind:themeFull="true"
                )
</template>

<script>
import { mapGetters } from 'vuex';
import SidebarTab from '@/components/partials/SidebarTab';
import CartItem from '@/components/modules/CartItem';
import OrderCard from '@/components/modules/OrderCard';

export default {
    components: {
        SidebarTab,
        CartItem,
        OrderCard
    },
    data() {
        return {
            currentTab: 'current',
            currentOrders: [
                {
                    id: 1234,
                    pages: 36,
                    date: '14.11.2018',
                    time: '16:43:57',
                    faded: false
                }
            ],
            archiveOrders: [
                {
                    id: 1233,
                    pages: 36,
                    date: '14.11.2018',
                    time: '16:43:57'
                },
                {
                    id: 1235,
                    pages: 36,
                    date: '14.11.2018',
                    time: '16:43:57'
                },
                {
                    id: 1236,
                    pages: 36,
                    date: '14.11.2018',
                    time: '16:43:57'
                },
                {
                    id: 1237,
                    pages: 36,
                    date: '14.11.2018',
                    time: '16:43:57'
                },
                {
                    id: 1238,
                    pages: 36,
                    date: '14.11.2018',
                    time: '16:43:57'
                }
            ]
        };
    },
    computed: {
        ...mapGetters([
            'getOrderId',
            'isMobile'
        ]),
        archiveTabStyles() {
            return {
                'orders-list__tab_active': this.currentTab === 'archive',
                'orders-list__tab_disabled': this.archiveOrders.length < 1
            };
        }
    },
    mounted() {
        if (this.currentOrders.length > 0) {
            this.$store.commit('SET_CURRENT_ORDER_ID', this.currentOrders[0].id);
        }
    },
    methods: {
        switchTab(tab) {
            if (!this.isMobile) {
                if (tab === 'current' && this.currentTab !== 'current' && this.currentOrders.length > 0) {
                    // проверка того что мы переключаемся на таб "текущие", активный таб != "текущие"
                    // и текущие заказы не пусты
                    this.$store.commit('SET_CURRENT_ORDER_ID', this.currentOrders[0].id);
                }
                if (tab === 'archive' && this.currentTab !== 'archive' && this.archiveOrders.length > 0) {
                    // проверка того что мы переключаемся на таб "архив", активный таб != "архив"
                    // и архивные заказы не пусты
                    this.$store.commit('SET_CURRENT_ORDER_ID', this.archiveOrders[0].id);
                }
            }
            this.currentTab = tab;
        },
        deleteOrder(id) {
            this.currentOrders = this.currentOrders.filter(order => order.id !== id);
            this.$store.commit('SET_CURRENT_ORDER_ID', null);
            // TODO: axios.delete order
        }
    }
};
</script>

<style lang="sass" src="@/media/sass/components/modules/orders-list.sass"></style>
